import { createContext, useContext } from 'react';

import type { GroupedAutocompleteItem } from './types';

export type GroupedAutocompleteContextValue = {
  activeGroup: string | null;
  onActiveGroupChange: (group: string | null) => void;
  selectedItems: Record<string, string[]>;
  onSelectedItemsChange: (selectedItems: Record<string, string[]>) => void;
  groupItemsRef: React.MutableRefObject<GroupedAutocompleteItem[]>;
};

export const GroupedAutocompleteContext =
  createContext<GroupedAutocompleteContextValue | null>(null);

export const useGroupedAutocompleteContext = () => {
  const ctx = useContext(GroupedAutocompleteContext);
  if (!ctx) {
    throw new Error(
      'GroupedAutocomplete sub-components must be used within GroupedAutocomplete.Root',
    );
  }
  return ctx;
};
